<template>
  <div class="login_container">
    <div class="logo">
      <img src="@/assets/images/logo/logo2.jpg" :alt="appName" />
    </div>
    <div class="login_form">
      <van-form>
        <van-field v-model="loginInfo.mobilePhone" name="手机号" placeholder="请输入手机号" :rules="[{ required: true, message: '' }]" class="phone_box">
          <Icon iconClass="phone" slot="left-icon" />
        </van-field>
        <van-field v-model="loginInfo.authCode" name="验证码" placeholder="请输入验证码" :rules="[{ required: true, message: '' }]" class="code_box">
          <Icon iconClass="mail" slot="left-icon" />
          <template #button>
            <button class="send_code" ref="timeLocation" @click="sendCode($event)">
              发送验证码
            </button>
          </template>
        </van-field>
        <van-checkbox v-model="checked" checked-color="#ca2d2c" icon-size="16px" class="agree_box">我同意接受{{appFullName}}注册协议</van-checkbox>
        <van-button round native-type="submit" size="small" block color="#ca2d2c" @click="onLogin" class="login_btn">登 录</van-button>
      </van-form>
    </div>
    <div class="login_tips">
      登陆即代表您已阅读并同意<span @click="toProtocol">用户协议</span>和<span @click="toPrivate">隐私政策</span>
    </div>
  </div>
</template>
<script>
import { mapState, mapActions } from "vuex";
import { testMobilePhone, wxUserInfoAuthorize, getUrlParamByKey,getRandomStr32 } from "@/utils";
import loginApi from "@/api/apis/login.js";
var fromPath = { path: "/", query: {} };
export default {
  name: "Login",
  data() {
    return {
      memberId: null,
      loginInfo: {
        mobilePhone: "",
        authCode: "",
      },
      timePicker: null,
      checked: false,
    };
  },
  computed: {
    ...mapState("app", ["userInfo", "nodeCode", "wxAppId", "appName", "appFullName","deviceId"]),
  },
  methods: {
    ...mapActions("app", ["setUserInfo","setDeviceId"]),
    /* 发送验证码 */
    sendCode(e) {
      var _this = this;
      if (testMobilePhone(_this.loginInfo.mobilePhone)) {
        var time = 59;
        if (_this.$refs.timeLocation) {
          _this.$refs.timeLocation.innerHTML = "请(" + time + ")秒后重新获取";
          _this.$refs.timeLocation.disabled = true;
        }
        _this.timePicker = setInterval(function () {
          time--;
          if (time == 0) {
            clearInterval(_this.timePicker);
            if (_this.$refs.timeLocation) {
              _this.$refs.timeLocation.innerHTML = "发送验证码";
              _this.$refs.timeLocation.disabled = false;
            }
          } else {
            if (_this.$refs.timeLocation) {
              _this.$refs.timeLocation.innerHTML =
                "请(" + time + ")秒后重新获取";
            }
          }
        }, 1000);

        var params = {
          mobilephone: _this.loginInfo.mobilePhone,
          nodeCode: _this.nodeCode,
        };

        loginApi
          .getAuthCode(params)
          .then((res) => {
            if (res.suc == 1) {
              _this.$toast({
                message: "发送成功",
                position: "center",
              });
            } else {
              _this.$toast({
                message: res.message||"发送验证码失败,请稍后再试!",
                position: "center",
              });
            }
          })
          .catch((err) => {
            _this.$toast({
              message: "接口调用出错",
              position: "center",
            });
          });
      } else {
        _this.$toast({
          message: "请输入正确的手机号",
          position: "center",
        });
      }
    },
    /* 手机验证码登录 */
    onLogin() {
      var _this = this;
      if (testMobilePhone(_this.loginInfo.mobilePhone)) {
        if (!_this.loginInfo.authCode || _this.loginInfo.authCode.length != 6) {
          return _this.$toast({
            message: "请输入正确的验证码",
            position: "center",
          });
        }

        if (!_this.checked) {
          return _this.$toast({
            message: "请同意接受" + _this.appFullName + "注册协议",
            position: "center",
          });
        }

        var params = {
          mobilePhone: _this.loginInfo.mobilePhone,
          authCode: _this.loginInfo.authCode,
          platformFlag: 2, // 0.匿名登录，1.手机号密码登录，2.手机号短信验证码登录 ,3.微信，4.QQ，5.微博,6.苹果账号
          isLogin: true,
        };
        loginApi
          .getMemberByToken(params)
          .then((res) => {
            if (res.suc == 1) {
              clearInterval(_this.timePicker);
              let userInfo = res.data.memberInfo;
              _this.setUserInfo(userInfo);
              // _this.goBackOrHome();
              _this.$router.back(-1);
            } else {
              _this.$toast({
                message: res.message || res.text,
                position: "center",
              });
            }
          })
          .catch((err) => {
            _this.$toast({
              message: "接口调用出错",
              position: "center",
            });
          });
      } else {
        _this.$toast({
          message: "请输入正确的手机号",
          position: "center",
        });
      }
    },
    /* 直接返回原页面或者跳转首页 */
    goBackOrHome() {
      this.$router.replace({
        path: fromPath.path,
        query: fromPath.query,
      });
    },
    /* 跳转用户协议 */
    toProtocol() {
      this.$router.push("/protocol");
    },
    /* 跳转隐私协议 */
    toPrivate() {
      this.$router.push("/private");
    }
  },
  /* 进入路由之前执行的函数,写在组件里可根据路由进行页面判断或传值 */
  beforeRouteEnter(to, from, next) {
    fromPath.path = from.path;
    fromPath.query = from.query;
    next();
  },
  mounted() {
    var _this = this;
    _this.memberId = !!_this.userInfo ? _this.userInfo.id : null;

    if (!this.deviceId) {
      var deviceId = getRandomStr32();
      this.setDeviceId(deviceId);
    }

    var token = window.localStorage.getItem("xc-share-accessToken");
    let tokenTime = window.localStorage.getItem("xc-share-tokenTime");
    var expiresIn = window.localStorage.getItem("xc-share-expiresIn");

    let time = new Date().getTime();
    /* 已登录，而且token没有过期，直接返回原页面或者跳转首页 */
    if (!!token && !!_this.memberId && (time - parseInt(tokenTime) <= (parseInt(expiresIn) - 5) * 1000)) {
      _this.$router.back(-1);
    } else {
      return
      /* 微信授权登录，首先要判断是否是在微信浏览器中 */
      var ua = navigator.userAgent.toLowerCase();
      if (/MicroMessenger/gi.test(ua)) {
        /* 判断是否是微信授权后重定向回来 */

        var code = getUrlParamByKey("code");
        var state = getUrlParamByKey("state");
        if ("login" == state && code && code.length > 0) {
          var params = { code: code, nodeCode: _this.nodeCode };
          loginApi
            .getWeixinMemberInfo(params)
            .then((res) => {
              if (res.suc == 1) {
                let userInfo = res.data.memberInfo;
                _this.setUserInfo(userInfo);
                // _this.goBackOrHome();
                _this.$router.back(-2);
              } else {
                _this.$toast({
                  message: "登录失败，请重试！",
                  position: "center",
                });
              }
            })
            .catch((err) => {
              _this.$toast({
                message: "登录失败，请重试！",
                position: "center",
              });
            });
        } else {
          wxUserInfoAuthorize(window.location.href, _this.wxAppId, "login");
        }
      }
    }

  
  },
};
</script>
<style lang="scss" scoped>
.login_container {
  position: relative;
  max-width: 750px;
  min-height: 100vh;
  width: 100%;
  margin: auto;
  overflow: hidden;
  .logo {
    width: 36%;
    margin: 33% auto 30px;
    img {
      width: 100%;
    }
  }
  .login_form {
    width: 62.5%;
    margin: 0 auto;
    .van-form {
      .tj-svg-icon {
        color: #bdbdbd;
        font-size: 18px;
      }
      .van-cell {
        padding: 15px 5px 5px;
        border-top: none;
        border-bottom: 1px solid #e8e8e8;
        &::after {
          display: none;
        }
        &.phone_box {
          /deep/.van-field__left-icon {
            margin-right: 0;
            .phone {
              position: relative;
              left: -2px;
              font-size: 20px;
            }
          }
        }
        &.code_box {
          padding-right: 0;
          .send_code {
            height: 20px;
            padding-left: 0;
            padding-right: 0;
            line-height: 20px;
            border: none;
            background-color: transparent;
            color: #ca2d2c;
            font-size: 12px;
            &:disabled {
              padding-left: 4px;
              padding-right: 4px;
              background-color: #ececec;
              color: #8f8f8f;
              border-radius: 8px;
            }
          }
        }
      }
      .agree_box {
        padding: 10px 5px;
        // font-family: "STSong";
        font-size: 12px;
        /deep/.van-checkbox__label {
          color: #b7adad;
          // font-family: "STSong";
          font-size: 12px;
        }
      }
      .login_btn {
        margin-top: 20px;
        // font-family: "STSong";
        font-size: 16px;
      }
    }
  }
  .login_tips {
    margin: 30% auto 0;
    text-align: center;
    color: #c4c4c4;
    font-size: 12px;
    white-space: nowrap;
    span {
      margin-left: 5px;
      margin-right: 5px;
      text-decoration: underline;
    }
  }
}
</style>